import { ProjectBudgetStatus } from "../enums/project-budget-status";
import { AllowedActionsMap, StateMachine, TransitionMap } from "./state-machine";

export type ProjectBudgetAction =
  | 'Submit'
  | 'Return'
  | 'Resubmit'
  | 'Approve'
  | 'Reject'
  //UI Only
  | 'Edit'
  | 'CreateReallocation';

// --- EXACT MIRROR of EnsureValidTransition on the server ---
const transitions: TransitionMap<ProjectBudgetStatus> = {
  [ProjectBudgetStatus.Draft]: [
    ProjectBudgetStatus.Submitted
  ],

  [ProjectBudgetStatus.Submitted]: [
    ProjectBudgetStatus.Returned,
    ProjectBudgetStatus.Approved,
    ProjectBudgetStatus.Rejected,
  ],

  [ProjectBudgetStatus.Returned]: [
    ProjectBudgetStatus.Resubmitted
  ],

  [ProjectBudgetStatus.Resubmitted]: [
    ProjectBudgetStatus.Returned,
    ProjectBudgetStatus.Approved,
    ProjectBudgetStatus.Rejected,
  ],
  // Approved / Rejected are terminal
};

// --- EXACT MIRROR of EnsureValidAction on the server ---
const allowedActions: AllowedActionsMap<ProjectBudgetStatus, ProjectBudgetAction> = {
  [ProjectBudgetStatus.Draft]: ['Edit', 'Submit'],

  [ProjectBudgetStatus.Submitted]: ['Return', 'Approve', 'Reject'],

  [ProjectBudgetStatus.Returned]: ['Edit', 'Resubmit'],

  [ProjectBudgetStatus.Resubmitted]: ['Return', 'Approve', 'Reject'],

  [ProjectBudgetStatus.Approved]: ['CreateReallocation'],

  [ProjectBudgetStatus.Rejected]: [],
};

export const ProjectBudgetStateMachine = new StateMachine<ProjectBudgetStatus, ProjectBudgetAction>({
  transitions,
  allowedActions,
});